import { UnsubmittedRecording } from '~/webRecorder2/useUnsubmittedRecordings'
import { CallBotLayoutInfo, ServiceLogo } from '~/liveNotetaker/callBot/types'
import { SubjectId } from './string'

/**
 * Factory function for creating UnsubmittedRecording objects
 */
export function createUnsubmittedRecording(
  subjectId: SubjectId,
  overrides?: Partial<Omit<UnsubmittedRecording, keyof SubjectId | 'type'>>
): UnsubmittedRecording {
  return {
    ...subjectId,
    type: 'unsubmitted_recording',
    durationMs: 0,
    name: 'Untitled',
    ...overrides,
  }
}

/**
 * Factory function for creating CallBotLayoutInfo objects
 */
export function createCallBotLayoutInfo(
  id: string,
  overrides?: Partial<Omit<CallBotLayoutInfo, 'id' | 'type'>>
): CallBotLayoutInfo {
  const defaultServiceLogo: ServiceLogo = {
    path: '/images/logo-generic.svg',
    className: 'h-2.5',
  }

  return {
    type: 'call_bot_layout_info',
    id,
    status: 'Idle',
    status_indicator: 'idle',
    buttons: [],
    service_logo: defaultServiceLogo,
    ...overrides,
  }
}
